import logoUmss from 'assets/images/logoUmss.png'
import { Outlet } from 'react-router-dom'

export default function LayoutNotificacion() {
    return (
        <>
            <div className='header-bg py-2 px-5'>
                <div className='container-fluid'>
                <div className='rounded' style={{width: '8rem'}}>
                    <img src={logoUmss} alt='imagen' className='w-100 rounded' />
                </div>
                </div>
            </div>
            <div className='page-content'>
                <Outlet />
            </div>
        </>
    )
}
